import React from 'react'
import PropTypes from 'prop-types'
import {Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useIntl} from 'react-intl'
import {useMultiStyleConfig} from '@chakra-ui/react'

const Discount = ({price, variant, ...extraProps}) => {
    const intl = useIntl()
    const listPriceText = `(-${intl.formatNumber(price, {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    })})`
    const styles = useMultiStyleConfig('PriceCard', {variant})
    return (
        <Text {...styles.discount} {...extraProps}>
            {listPriceText}
        </Text>
    )
}

Discount.propTypes = {
    price: PropTypes.number.isRequired,
    extraProps: PropTypes.object,
    variant: PropTypes.string,
}

export default Discount
